
// Módulo de Imposto de Renda (IRPF / LCDPR)
// Estrutura de 3 Abas: Dashboard, Avulsos, Conferência

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};

window.FazendaRP.Pages.ir = {
    // State
    currentState: {
        years: [new Date().getFullYear() + 1],
        activeTab: 'audit',
        loading: false,
        cacheAvaliacoes: {}
    },

    render: async function (container) {
        container.innerHTML = this.renderLayout();
        this.bindEvents();
        await this.refreshAll();
    },

    renderLayout: function () {
        const currentYear = new Date().getFullYear();
        const availableYears = [currentYear + 1, currentYear, currentYear - 1, currentYear - 2];

        return `
            <div id="ir-module-container" style="padding: 20px; max-width: 1300px; margin: 0 auto;">
                
                <!-- HEADER -->
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
                    <div>
                        <h2 style="margin: 0; color: #059669; display: flex; align-items: center; gap: 10px;">
                            <i class="fas fa-balance-scale"></i> Planejamento Fiscal (IRPF)
                        </h2>
                        <p style="margin: 5px 0 0; color: #6b7280;">Simulação e Conferência para LCDPR</p>
                    </div>
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <label style="color: #374151; font-weight: 500;">Anos Base:</label>
                        <div id="ir-year-chips" style="display: flex; gap: 5px; background: white; padding: 5px; border-radius: 6px; border: 1px solid #d1d5db;">
                            ${availableYears.map(y => {
            const isChecked = this.currentState.years.includes(y);
            return `
                                    <label class="year-chip ${isChecked ? 'selected' : ''}" style="cursor: pointer; padding: 5px 12px; border-radius: 4px; font-size: 0.9rem; font-weight: 600; transition: all 0.2s; ${isChecked ? 'background: #059669; color: white;' : 'background: #f3f4f6; color: #4b5563;'}">
                                        <input type="checkbox" value="${y}" ${isChecked ? 'checked' : ''} style="display:none;">
                                        ${y}
                                    </label>
                                `;
        }).join('')}
                        </div>
                    </div>
                </div>

                <!-- TABS -->
                <div style="display: flex; gap: 20px; border-bottom: 2px solid #e5e7eb; margin-bottom: 25px;">
                    <button class="ir-tab-btn" data-tab="dash">1. Simulação / Dashboard</button>
                    <button class="ir-tab-btn" data-tab="entry">2. Lançamentos Avulsos</button>
                    <button class="ir-tab-btn active" data-tab="audit">3. Conferência (Pente Fino)</button>
                </div>

                <!-- CONTENT AREAS -->
                
                <!-- TAB 1: DASHBOARD -->
                <div id="tab-dash" class="ir-tab-content" style="display: none;">
                    <div id="ir-simulation-results">Carregando simulação...</div>
                </div>

                <!-- TAB 2: AVULSOS -->
                <div id="tab-entry" class="ir-tab-content" style="display: none;">
                    <div style="background: white; padding: 25px; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
                        <h3 style="margin-top: 0; color: #374151;">Novo Lançamento Avulso (Despesas Dedutíveis)</h3>
                        <p style="color: #6b7280; font-size: 0.9rem; margin-bottom: 20px;">
                            Registre aqui despesas que <strong>não transitam pelo caixa</strong> da fazenda (Ex: Juros de Financiamento, Permutas), mas que são dedutíveis no IR.
                        </p>

                        <form id="ir-avulso-form">
                            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 15px;">
                                <div>
                                    <label style="display: block; margin-bottom: 5px; font-size: 0.85rem; font-weight: 500;">Data Emissão</label>
                                    <input type="date" id="av-emissao" class="form-control" required>
                                </div>
                                <div>
                                    <label style="display: block; margin-bottom: 5px; font-size: 0.85rem; font-weight: 500;">Data Vencimento (Competência IR)</label>
                                    <input type="date" id="av-vencimento" class="form-control" required>
                                </div>
                            </div>
                             <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 15px;">
                                <div>
                                    <label style="display: block; margin-bottom: 5px; font-size: 0.85rem; font-weight: 500;">Nº Documento</label>
                                    <input type="text" id="av-doc" class="form-control" placeholder="Ex: Contrato 123">
                                </div>
                                <div>
                                    <label style="display: block; margin-bottom: 5px; font-size: 0.85rem; font-weight: 500;">Fornecedor / Descrição</label>
                                    <input type="text" id="av-fornecedor" class="form-control" placeholder="Ex: Banco do Brasil" required>
                                </div>
                            </div>
                             <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 20px;">
                                <div>
                                    <label style="display: block; margin-bottom: 5px; font-size: 0.85rem; font-weight: 500;">Valor (R$)</label>
                                    <input type="number" step="0.01" id="av-valor" class="form-control" placeholder="0,00" required>
                                </div>
                                <div style="display: flex; align-items: flex-end;"> 
                                     <div style="width: 100%; padding: 10px; background: #e5e7eb; border-radius: 6px; color: #6b7280; text-align: center; font-size: 0.9rem;">
                                         <i class="fas fa-lock"></i> Tipo: Despesa Dedutível
                                     </div>
                                </div>
                            </div>

                            <div style="text-align: right;">
                                <button type="submit" style="background: #059669; color: white; border: none; padding: 10px 20px; border-radius: 6px; cursor: pointer; font-weight: 600;">
                                    <i class="fas fa-plus"></i> Salvar Lançamento
                                </button>
                            </div>
                        </form>

                        <hr style="margin: 30px 0; border: 0; border-top: 1px solid #e5e7eb;">

                        <h4 style="color: #374151;">Últimos Lançamentos Avulsos</h4>
                        <div id="avulsos-list-container">Carregando...</div>
                    </div>
                </div>

                <!-- TAB 3: AUDIT -->
                <div id="tab-audit" class="ir-tab-content">
                    <div style="background: #ecfdf5; color: #065f46; padding: 15px; border-radius: 6px; margin-bottom: 20px; border: 1px solid #a7f3d0; display: flex; gap: 10px;">
                        <i class="fas fa-info-circle" style="margin-top: 3px;"></i>
                        <div>
                            <strong>Conferência Oficial (Pente Fino)</strong><br>
                            Esta lista unifica o Financeiro + Lançamentos Avulsos. Marque o que deve entrar no cálculo do IR.<br>
                            <small>As alterações aqui NÃO modificam os lançamentos originais.</small>
                        </div>
                    </div>

                    <div style="background: white; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); overflow: hidden;">
                         <!-- Filter Bar -->
                        <div style="padding: 15px; border-bottom: 1px solid #e5e7eb; background: #f9fafb; display: flex; gap: 15px; align-items: center;">
                            <button id="btn-print-audit" class="btn btn-secondary" style="padding: 6px 12px; border: 1px solid #d1d5db; border-radius: 4px; background: white; cursor: pointer; color: #374151;">
                                <i class="fas fa-print"></i> Imprimir
                            </button>
                            <button id="btn-export-audit" class="btn btn-secondary" style="padding: 6px 12px; border: 1px solid #059669; border-radius: 4px; background: #059669; color: white; cursor: pointer;">
                                <i class="fas fa-file-excel"></i> Exportar
                            </button>
                            <div style="width: 1px; height: 24px; background: #e5e7eb; margin: 0 5px;"></div>
                            <input type="text" id="audit-search" placeholder="Buscar..." style="padding: 8px; border: 1px solid #d1d5db; border-radius: 4px; width: 250px;">
                            
                            <!-- Stats Display -->
                            <div style="display: flex; gap: 20px; margin-left: auto; font-size: 0.9rem;">
                                <div style="background: #e0f2fe; padding: 5px 10px; border-radius: 4px; color: #0369a1; border: 1px solid #bae6fd;">
                                    <i class="fas fa-file-invoice"></i> NFe: <strong id="audit-nfe-count">0</strong>
                                </div>
                                <div style="align-self: center; color: #6b7280;">
                                    Total Selecionado: <strong id="audit-total-selected" style="color: #059669;">R$ 0,00</strong>
                                </div>
                            </div>
                        </div>

                        <div style="max-height: 600px; overflow-y: auto;">
                            <table style="width: 100%; border-collapse: collapse;">
                                <thead style="background: #f3f4f6; position: sticky; top: 0; z-index: 10;">
                                    <tr>
                                        <th style="padding: 12px; text-align: left; color: #6b7280; font-size: 0.75rem; text-transform: uppercase;">IR?</th>
                                        <th style="padding: 12px; text-align: left; color: #6b7280; font-size: 0.75rem; text-transform: uppercase;">Emissão</th>
                                        <th style="padding: 12px; text-align: left; color: #6b7280; font-size: 0.75rem; text-transform: uppercase;">Vencimento</th>
                                        <th style="padding: 12px; text-align: left; color: #6b7280; font-size: 0.75rem; text-transform: uppercase;">Origem</th>
                                        <th style="padding: 12px; text-align: left; color: #6b7280; font-size: 0.75rem; text-transform: uppercase;">Nº Doc</th>
                                        <th style="padding: 12px; text-align: left; color: #6b7280; font-size: 0.75rem; text-transform: uppercase;">Fornecedor</th>
                                        <th style="padding: 12px; text-align: left; color: #6b7280; font-size: 0.75rem; text-transform: uppercase;">Descrição</th>
                                        <th style="padding: 12px; text-align: right; color: #6b7280; font-size: 0.75rem; text-transform: uppercase;">Valor</th>
                                    </tr>
                                </thead>
                                <tbody id="audit-table-body">
                                    <!-- Dynamic Rows -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>

            <style>
                .ir-tab-btn { padding: 10px 15px; background: none; border: none; cursor: pointer; color: #6b7280; font-weight: 500; font-size: 1rem; border-bottom: 2px solid transparent; transition: all 0.2s; }
                .ir-tab-btn:hover { color: #059669; }
                .ir-tab-btn.active { color: #059669; border-bottom-color: #059669; font-weight: 700; }
                .form-control { width: 100%; padding: 8px 10px; border: 1px solid #d1d5db; border-radius: 4px; box-sizing: border-box; }
                
                /* Switch Style */
                .switch { position: relative; display: inline-block; width: 36px; height: 20px; }
                .switch input { opacity: 0; width: 0; height: 0; }
                .slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #cbd5e1; transition: .4s; border-radius: 20px; }
                .slider:before { position: absolute; content: ""; height: 14px; width: 14px; left: 3px; bottom: 3px; background-color: white; transition: .4s; border-radius: 50%; }
                input:checked + .slider { background-color: #059669; }
                input:checked + .slider:before { transform: translateX(16px); }

                .row-excluded { opacity: 0.5; background: #f9fafb; text-decoration: line-through; }
                .row-excluded td { color: #9ca3af; }
            </style>
        `;
    },

    bindEvents: function () {
        // Tab Switching
        document.querySelectorAll('.ir-tab-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const tab = e.target.dataset.tab;
                document.querySelectorAll('.ir-tab-btn').forEach(b => b.classList.remove('active'));
                e.target.classList.add('active');

                document.querySelectorAll('.ir-tab-content').forEach(c => c.style.display = 'none');
                document.getElementById(`tab-${tab}`).style.display = 'block';

                if (tab === 'dash') this.renderDashboard();
                if (tab === 'entry') this.loadAvulsosList();
            });
        });

        // Year Chips Selector
        const chipsContainer = document.getElementById('ir-year-chips');
        if (chipsContainer) {
            chipsContainer.querySelectorAll('input[type="checkbox"]').forEach(input => {
                input.addEventListener('change', (e) => {
                    const year = parseInt(e.target.value);
                    if (e.target.checked) {
                        if (!this.currentState.years.includes(year)) this.currentState.years.push(year);
                    } else {
                        this.currentState.years = this.currentState.years.filter(y => y !== year);
                    }

                    // Update visual state
                    e.target.parentElement.classList.toggle('selected', e.target.checked);
                    e.target.parentElement.style.background = e.target.checked ? '#059669' : '#f3f4f6';
                    e.target.parentElement.style.color = e.target.checked ? 'white' : '#4b5563';

                    this.refreshAll();
                });
            });
        }

        // Avulso Form Submit
        document.getElementById('ir-avulso-form').addEventListener('submit', async (e) => {
            e.preventDefault();
            if (this.currentState.editingAvulsoId) {
                await this.updateAvulso();
            } else {
                await this.saveAvulso();
            }
        });

        // Search in Audit
        document.getElementById('audit-search')?.addEventListener('input', (e) => {
            const term = e.target.value.toLowerCase();
            const rows = document.querySelectorAll('#audit-table-body tr');
            rows.forEach(row => {
                const text = row.innerText.toLowerCase();
                row.style.display = text.includes(term) ? '' : 'none';
            });
        });

        // Print & Export
        document.getElementById('btn-print-audit')?.addEventListener('click', () => this.printAudit());
        document.getElementById('btn-export-audit')?.addEventListener('click', () => this.exportAuditCSV());
    },

    printAudit: function () {
        // Collect visible rows or current data
        const term = (document.getElementById('audit-search')?.value || '').toLowerCase();

        // Filter logic same as UI
        const filtered = this.unifiedData.filter(item => {
            if (!term) return true;
            const searchStr = `${item.num_doc} ${item.provider} ${item.description} ${item.value}`.toLowerCase();
            return searchStr.includes(term);
        });
        // Sort by date asc
        filtered.sort((a, b) => new Date(a.date) - new Date(b.date));

        const logoDataUrl = window.FazendaRP_Logo || "";
        const now = new Date();
        const years = this.currentState.years.join(', ');

        const rows = filtered.map(item => {
            const styleColor = item.tipo === 'RECEITA' ? 'color:#059669' : 'color:#dc2626';
            const statusIR = item.is_active ? 'SIM' : 'NÃO';

            return `
                 <tr>
                    <td>${this.formatDate(item.emissao)}</td>
                    <td>${this.formatDate(item.date)}</td>
                    <td>${item.origin_type}</td>
                    <td>${item.num_doc}</td>
                    <td>${item.provider}</td>
                    <td>${item.description}</td>
                    <td style="text-align:center;">${statusIR}</td>
                    <td style="text-align:right; font-weight:bold; ${styleColor}">${this.formatCurrency(item.value)}</td>
                 </tr>
             `;
        }).join('');

        const win = window.open('', '_blank');
        win.document.write(`
            <html>
            <head>
                <title>Relatório Conferência IR</title>
                <style>
                    body { font-family: sans-serif; font-size: 12px; padding: 20px; }
                    table { width: 100%; border-collapse: collapse; margin-top: 15px; }
                    th { background: #065f46; color: white; padding: 5px; text-align:left; font-size:11px; }
                    td { border-bottom: 1px solid #ddd; padding: 5px; }
                    h1 { color: #065f46; margin: 0; }
                    @media print { th { background: #065f46 !important; -webkit-print-color-adjust: exact; } }
                </style>
            </head>
            <body>
                <div style="display:flex; justify-content:space-between; align-items:center; border-bottom:2px solid #065f46; padding-bottom:10px;">
                    <div>
                        <img src="${logoDataUrl}" style="height:50px;">
                        <h1>Conferência Pente Fino</h1>
                    </div>
                    <div style="text-align:right;">
                        <strong>Anos Base:</strong> ${years}<br>
                        <strong>Emissão:</strong> ${now.toLocaleString()}
                    </div>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>Emissão</th>
                            <th>Vencimento</th>
                            <th>Origem</th>
                            <th>Doc</th>
                            <th>Fornecedor</th>
                            <th>Descrição</th>
                            <th style="text-align:center;">IR?</th>
                            <th style="text-align:right;">Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${rows}
                    </tbody>
                </table>
                <script>window.onload = function() { window.print(); window.close(); }</script>
            </body>
            </html>
        `);
        win.document.close();
    },

    exportAuditCSV: function () {
        const term = (document.getElementById('audit-search')?.value || '').toLowerCase();
        const filtered = this.unifiedData.filter(item => {
            if (!term) return true;
            const searchStr = `${item.num_doc} ${item.provider} ${item.description} ${item.value}`.toLowerCase();
            return searchStr.includes(term);
        });
        filtered.sort((a, b) => new Date(a.date) - new Date(b.date));

        let csv = "Emissao;Vencimento;Origem;Doc;Fornecedor;Descricao;IR_Ativo;Valor\n";

        filtered.forEach(item => {
            const emissao = this.formatDate(item.emissao);
            const vencto = this.formatDate(item.date);
            const ir = item.is_active ? 'SIM' : 'NAO';
            const val = item.value.toString().replace('.', ',');
            const desc = (item.description || '').replace(/;/g, ' ');
            const forn = (item.provider || '').replace(/;/g, ' ');

            csv += `${emissao};${vencto};${item.origin_type};${item.num_doc};${forn};${desc};${ir};${val}\n`;
        });

        const blob = new Blob(["\\ufeff" + csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `conferencia_ir_${new Date().getTime()}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },

    refreshAll: async function () {
        const years = this.currentState.years;
        if (years.length === 0) {
            this.unifiedData = [];
            this.renderAuditGrid();
            return;
        }

        await this.loadAnaliseMask();

        this.unifiedData = [];
        await Promise.all([
            this.fetchFinanceiro(years),
            this.fetchAvulsos(years)
        ]);

        this.renderAuditGrid();
        this.loadAvulsosList();

        if (document.querySelector('.ir-tab-btn[data-tab="dash"]').classList.contains('active')) {
            this.renderDashboard();
        }
    },

    loadAnaliseMask: async function () {
        const { data, error } = await window.FazendaRP.supabase
            .from('financeiro_ir_analise')
            .select('*');

        if (error) { console.error("Error fetching analysis:", error); return; }

        this.currentState.cacheAvaliacoes = {};
        data.forEach(item => {
            if (item.lancamento_id) this.currentState.cacheAvaliacoes[`lan_${item.lancamento_id}`] = item.ir_ativo;
            if (item.deducao_id) this.currentState.cacheAvaliacoes[`ded_${item.deducao_id}`] = item.ir_ativo;
        });
    },

    fetchFinanceiro: async function (years) {
        if (!years || years.length === 0) return;

        const minYear = Math.min(...years);
        const maxYear = Math.max(...years);
        const start = `${minYear}-01-01`;
        const end = `${maxYear}-12-31`;

        const { data, error } = await window.FazendaRP.supabase
            .from('financeiro_lancamentos')
            .select('*, parceiros(nome)')
            .gte('data_vencimento', start)
            .lte('data_vencimento', end)
            .neq('status', 'Cancelado');

        if (!error && data) {
            data.forEach(item => {
                // Client-side filtering to ensure precise years (if range includes unwanted years)
                if (!years.includes(new Date(item.data_vencimento).getFullYear())) return;

                this.unifiedData.push({
                    id: item.id,
                    origin_type: 'FINANCEIRO',
                    date: item.data_vencimento,
                    emissao: item.data_emissao, // Strict

                    num_doc: item.num_doc || (item.detalhes ? item.detalhes.num_doc : '') || '-',
                    provider: item.parceiros ? item.parceiros.nome : (item.fornecedor || '-'),
                    description: item.descricao || 'Sem descrição',

                    value: item.detalhes?.valor_bruto || item.valor,
                    tipo: item.tipo,
                    status: item.status,
                    is_active: this.resolveStatus(item.id, 'lan', item),
                    is_nfe: (item.detalhes?.tipo_doc || '').includes('NF') || (item.num_doc && (item.num_doc.length > 3))
                });
            });
        }
    },

    fetchAvulsos: async function (years) {
        if (!years || years.length === 0) return;

        const minYear = Math.min(...years);
        const maxYear = Math.max(...years);
        const start = `${minYear}-01-01`;
        const end = `${maxYear}-12-31`;

        const { data, error } = await window.FazendaRP.supabase
            .from('financeiro_ir_deducoes')
            .select('*')
            .gte('data', start)
            .lte('data', end);

        if (!error && data) {
            data.forEach(item => {
                // Client-side filtering
                if (!years.includes(new Date(item.data).getFullYear())) return;

                this.unifiedData.push({
                    id: item.id,
                    origin_type: 'AVULSO',
                    date: item.data,
                    emissao: item.data_emissao,

                    num_doc: item.num_doc || 'AVULSO',
                    provider: item.fornecedor || 'Despesas Diversas',
                    description: item.fornecedor || '',

                    value: item.valor,
                    tipo: item.tipo,
                    is_active: this.resolveStatus(item.id, 'ded', item),
                    is_nfe: false
                });
            });
        }
    },

    resolveStatus: function (id, prefix, item) {
        const maskValue = this.currentState.cacheAvaliacoes[`${prefix}_${id}`];
        if (maskValue !== undefined) return maskValue;

        if (prefix === 'ded') return true;
        const doc = (item.detalhes?.tipo_doc || '').toUpperCase();
        if (doc.includes('NF') || doc.includes('FISCAL') || doc.includes('ELETRONICA')) return true;

        return true;
    },

    // CRUD Avulsos omitted for brevity (same as previous)
    saveAvulso: async function () {
        const payload = {
            data: document.getElementById('av-vencimento').value,
            data_emissao: document.getElementById('av-emissao').value, // Add Emission
            num_doc: document.getElementById('av-doc').value,
            fornecedor: document.getElementById('av-fornecedor').value,
            valor: parseFloat(document.getElementById('av-valor').value),
            tipo: 'DESPESA'
        };

        const { error } = await window.FazendaRP.supabase.from('financeiro_ir_deducoes').insert([payload]);

        if (error) { alert('Erro ao salvar: ' + error.message); }
        else { alert('Lançamento Avulso salvo!'); document.getElementById('ir-avulso-form').reset(); this.refreshAll(); }
    },
    loadAvulsosList: function () {
        const container = document.getElementById('avulsos-list-container');
        const avulsos = this.unifiedData.filter(i => i.origin_type === 'AVULSO');
        if (avulsos.length === 0) { container.innerHTML = '<p style="color:#9ca3af; text-align:center;">Nenhum lançamento avulso neste ano.</p>'; return; }

        // Sort by date descending (newest first)
        avulsos.sort((a, b) => new Date(b.date) - new Date(a.date));

        let html = `<table style="width:100%; border-collapse:collapse;"><thead style="background:#f9fafb; font-size:0.8rem; color:#6b7280;"><tr><th style="padding:10px; text-align:left;">Emissão</th><th style="padding:10px; text-align:left;">Vencimento</th><th style="padding:10px; text-align:left;">Doc</th><th style="padding:10px; text-align:left;">Fornecedor</th><th style="padding:10px; text-align:right;">Valor</th><th style="padding:10px; text-align:center;">Ação</th></tr></thead><tbody>`;
        avulsos.forEach(item => {
            html += `<tr style="border-bottom:1px solid #e5e7eb;"><td style="padding:10px;">${this.formatDate(item.emissao)}</td><td style="padding:10px;">${this.formatDate(item.date)}</td><td style="padding:10px;">${item.num_doc}</td><td style="padding:10px;">${item.provider}</td><td style="padding:10px; text-align:right;">${this.formatCurrency(item.value)}</td><td style="padding:10px; text-align:center;">
                <button onclick="window.FazendaRP.Pages.ir.editAvulso('${item.id}')" style="color:#f59e0b; background:none; border:none; cursor:pointer; margin-right:10px;" title="Editar"><i class="fas fa-edit"></i></button>
                <button onclick="window.FazendaRP.Pages.ir.deleteAvulso('${item.id}')" style="color:red; background:none; border:none; cursor:pointer;" title="Excluir"><i class="fas fa-trash"></i></button>
            </td></tr>`;
        });
        html += '</tbody></table>'; container.innerHTML = html;
    },

    deleteAvulso: async function (id) {
        if (!confirm('Excluir este lançamento avulso?')) return;
        await window.FazendaRP.supabase.from('financeiro_ir_deducoes').delete().eq('id', id);
        this.refreshAll();
    },

    editAvulso: function (id) {
        const item = this.unifiedData.find(i => i.id == id && i.origin_type === 'AVULSO');
        if (!item) return;

        this.currentState.editingAvulsoId = id;

        // Populate Form
        document.getElementById('av-emissao').value = item.emissao || '';
        document.getElementById('av-vencimento').value = item.date || '';
        document.getElementById('av-doc').value = item.num_doc === 'AVULSO' ? '' : item.num_doc;
        document.getElementById('av-fornecedor').value = item.provider;
        document.getElementById('av-valor').value = item.value;

        // Change Button/UI State
        const submitBtn = document.querySelector('#ir-avulso-form button[type="submit"]');
        submitBtn.innerHTML = '<i class="fas fa-save"></i> Atualizar Lançamento';
        submitBtn.style.background = '#f59e0b';

        // Scroll to form
        document.getElementById('tab-entry').scrollIntoView({ behavior: 'smooth' });
    },

    updateAvulso: async function () {
        const id = this.currentState.editingAvulsoId;
        if (!id) return;

        const payload = {
            data: document.getElementById('av-vencimento').value,
            data_emissao: document.getElementById('av-emissao').value || null,
            num_doc: document.getElementById('av-doc').value,
            fornecedor: document.getElementById('av-fornecedor').value,
            valor: parseFloat(document.getElementById('av-valor').value),
        };

        const { error } = await window.FazendaRP.supabase
            .from('financeiro_ir_deducoes')
            .update(payload)
            .eq('id', id);

        if (error) {
            alert('Erro ao atualizar: ' + error.message);
        } else {
            alert('Lançamento atualizado!');
            this.resetForm();
            this.refreshAll();
        }
    },

    resetForm: function () {
        document.getElementById('ir-avulso-form').reset();
        this.currentState.editingAvulsoId = null;
        const submitBtn = document.querySelector('#ir-avulso-form button[type="submit"]');
        submitBtn.innerHTML = '<i class="fas fa-plus"></i> Salvar Lançamento';
        submitBtn.style.background = '#059669';
    },

    saveAvulso: async function () {
        const payload = {
            data: document.getElementById('av-vencimento').value,
            data_emissao: document.getElementById('av-emissao').value || null, // Add Emission (Handle empty as null)
            num_doc: document.getElementById('av-doc').value,
            fornecedor: document.getElementById('av-fornecedor').value,
            valor: parseFloat(document.getElementById('av-valor').value),
            tipo: 'DESPESA'
        };

        const { error } = await window.FazendaRP.supabase.from('financeiro_ir_deducoes').insert([payload]);

        if (error) { alert('Erro ao salvar: ' + error.message); }
        else { alert('Lançamento Avulso salvo!'); this.resetForm(); this.refreshAll(); }
    },

    // ============================================
    // LOGIC: AUDIT & TOGGLE (FIXED)
    // ============================================

    renderAuditGrid: function () {
        const tbody = document.getElementById('audit-table-body');
        const sortedData = [...this.unifiedData].sort((a, b) => new Date(a.date) - new Date(b.date));

        let totalSelected = 0;
        let nfeCount = 0;

        tbody.innerHTML = sortedData.map(item => {
            if (item.is_active) totalSelected += item.value;

            if (item.origin_type === 'FINANCEIRO' && item.is_nfe) { nfeCount++; }

            const badgeClass = item.origin_type === 'FINANCEIRO' ? 'background:#dbeafe; color:#1e40af; border:1px solid #93c5fd;' : 'background:#fef9c3; color:#854d0e; border:1px solid #fde047;';
            const valueStyle = item.is_active ? '' : 'text-decoration:line-through; opacity:0.5; color:#9ca3af;'; // Better visual cue

            return `
                <tr class="${item.is_active ? '' : 'row-excluded'}" style="border-bottom:1px solid #e5e7eb; transition: background 0.3s;">
                    <td style="padding:12px;">
                        <label class="switch">
                            <input type="checkbox" ${item.is_active ? 'checked' : ''} 
                                onchange="window.FazendaRP.Pages.ir.toggleItem('${item.id}', '${item.origin_type}', this.checked)">
                            <span class="slider"></span>
                        </label>
                    </td>
                    <td style="padding:12px;">
                        ${item.origin_type === 'FINANCEIRO' && item.status !== 'Pago' ? '<i class="fas fa-clock" style="color:#f59e0b; margin-right:4px;" title="Em Aberto"></i>' : ''}
                        ${item.origin_type === 'FINANCEIRO' && item.status === 'Pago' ? '<i class="fas fa-check-circle" style="color:#10b981; margin-right:4px;" title="Pago"></i>' : ''}
                </td>
                <td style="padding:12px; font-size:0.9rem;">${this.formatDate(item.emissao)}</td>
                <td style="padding:12px; font-size:0.9rem;">${this.formatDate(item.date)}</td>
                <td style="padding:12px;"><span style="padding:3px 8px; border-radius:4px; font-size:0.75rem; font-weight:600; ${badgeClass}">${item.origin_type === 'FINANCEIRO' ? 'FIN' : 'AVULSO'}</span></td>
                    <td style="padding:12px; font-size:0.9rem; font-weight:500;">
                        ${item.num_doc} ${item.is_nfe ? '<i class="fas fa-check-circle" style="color:#059669; font-size:0.7rem; margin-left:4px;" title="Reconhecido como NFe"></i>' : ''}
                    </td>
                    <td style="padding:12px; font-size:0.9rem;">${item.provider}</td>
                    <td style="padding:12px; font-size:0.85rem; color:#6b7280;">${item.description}</td>
                    <!-- Value Column with Strikethrough Logic applied dynamically -->
                    <td style="padding:12px; text-align:right; font-family:monospace; font-size:1rem; color:${item.tipo === 'RECEITA' ? '#059669' : '#dc2626'};">
                        <span id="val-${item.id}" style="${valueStyle}">
                            ${this.formatCurrency(item.value)}
                        </span>
                    </td>
                </tr>
            `;
        }).join('');

        document.getElementById('audit-total-selected').innerText = this.formatCurrency(totalSelected);
        document.getElementById('audit-nfe-count').innerText = nfeCount;
    },

    toggleItem: async function (id, originType, isChecked) {
        // 1. Optimistic Update (Local State)
        const item = this.unifiedData.find(i => i.id == id && i.origin_type == originType);
        if (item) {
            item.is_active = isChecked; // Update main array state
            this.recalcAuditTotals(); // Update UI Header

            // Visual Update Row (Optional, prevents Flicker)
            const valEl = document.getElementById(`val-${id}`);
            if (valEl) {
                if (isChecked) {
                    valEl.style.textDecoration = 'none';
                    valEl.style.opacity = '1';
                    valEl.style.color = ''; // inherit Color
                } else {
                    valEl.style.textDecoration = 'line-through';
                    valEl.style.opacity = '0.5';
                    valEl.style.color = '#9ca3af';
                }
            }
        }

        // 2. Database Update (Background)
        let error;
        // const payload = { ir_ativo: isChecked, created_at: new Date() };

        if (originType === 'FINANCEIRO') {
            const { err } = await window.FazendaRP.supabase
                .from('financeiro_ir_analise')
                .upsert({ lancamento_id: id, ir_ativo: isChecked }, { onConflict: 'lancamento_id' });
            error = err;
        } else {
            const { err } = await window.FazendaRP.supabase
                .from('financeiro_ir_analise')
                .upsert({ deducao_id: id, ir_ativo: isChecked }, { onConflict: 'deducao_id' });
            error = err;
        }

        if (error) console.error("Erro no toggle IR:", error);
    },

    recalcAuditTotals: function () {
        let totalSelected = 0;
        this.unifiedData.forEach(item => {
            if (item.is_active) totalSelected += item.value;
        });
        document.getElementById('audit-total-selected').innerText = this.formatCurrency(totalSelected);
    },

    renderDashboard: function () {
        // Dashboard uses unifiedData, effectively sharing state with Audit
        const cleanData = this.unifiedData.filter(i => i.is_active);

        let totalReceitas = 0;
        let totalDespesas = 0;

        cleanData.forEach(item => {
            if ((item.tipo || '').toUpperCase().includes('RECEITA')) {
                totalReceitas += item.value;
            } else {
                totalDespesas += item.value;
            }
        });

        const lucroRealBase = totalReceitas - totalDespesas;
        const impostoReal = this.calculateIRPF(lucroRealBase);

        const basePresumido = totalReceitas * 0.20;
        const impostoPresumido = this.calculateIRPF(basePresumido);

        const diff = Math.abs(impostoReal - impostoPresumido);
        const melhor = impostoReal < impostoPresumido ? 'Lucro Real (Livro Caixa)' : 'Lucro Presumido';
        const economia = diff;

        document.getElementById('ir-simulation-results').innerHTML = `
            <div style="display:grid; grid-template-columns: 1fr 1fr; gap:20px;">
                <div style="background:white; padding:20px; border-radius:8px; border-top: 4px solid #3b82f6;">
                    <h3 style="color:#1e40af; margin-top:0;">Scenario A: Lucro Real (Livro Caixa)</h3>
                    <p style="font-size:0.9rem; color:#6b7280;">Receitas - Despesas = Base de Cálculo</p>
                    
                    <div style="margin-top:15px; display:flex; justify-content:space-between; border-bottom:1px solid #eee;">
                        <span>Receitas Consideradas:</span>
                        <span style="color:#059669;">${this.formatCurrency(totalReceitas)}</span>
                    </div>
                    <div style="margin-top:10px; display:flex; justify-content:space-between; border-bottom:1px solid #eee;">
                        <span>Despesas Dedutíveis:</span>
                        <span style="color:#dc2626;">- ${this.formatCurrency(totalDespesas)}</span>
                    </div>
                    <div style="margin-top:10px; display:flex; justify-content:space-between; font-weight:bold;">
                        <span>Base de Cálculo:</span>
                        <span>${this.formatCurrency(lucroRealBase)}</span>
                    </div>

                    <div style="margin-top:20px; text-align:center; padding:15px; background:#eff6ff; border-radius:8px;">
                        <span style="display:block; font-size:0.8rem; color:#60a5fa;">IMPOSTO ESTIMADO</span>
                        <strong style="font-size:1.5rem; color:#1d4ed8;">${this.formatCurrency(impostoReal)}</strong>
                    </div>
                </div>

                <div style="background:white; padding:20px; border-radius:8px; border-top: 4px solid #8b5cf6;">
                    <h3 style="color:#5b21b6; margin-top:0;">Scenario B: Lucro Presumido</h3>
                    <p style="font-size:0.9rem; color:#6b7280;">20% da Receita Bruta = Base de Cálculo</p>
                    
                    <div style="margin-top:15px; display:flex; justify-content:space-between; border-bottom:1px solid #eee;">
                        <span>Receita Bruta:</span>
                        <span style="color:#059669;">${this.formatCurrency(totalReceitas)}</span>
                    </div>
                    <div style="margin-top:10px; display:flex; justify-content:space-between; font-weight:bold;">
                        <span>Base (20%):</span>
                        <span>${this.formatCurrency(basePresumido)}</span>
                    </div>

                    <div style="margin-top:20px; text-align:center; padding:15px; background:#f5f3ff; border-radius:8px;">
                        <span style="display:block; font-size:0.8rem; color:#a78bfa;">IMPOSTO ESTIMADO</span>
                        <strong style="font-size:1.5rem; color:#6d28d9;">${this.formatCurrency(impostoPresumido)}</strong>
                    </div>
                </div>
            </div>

            <div style="margin-top:20px; background:#ecfdf5; padding:20px; border-radius:8px; text-align:center; border:1px solid #a7f3d0;">
                <h3 style="margin:0; color:#065f46;">Melhor Opção: ${melhor}</h3>
                <p style="margin:5px 0 0; color:#064e3b;">Economia estimada de <strong>${this.formatCurrency(economia)}</strong></p>
            </div>
        `;
    },

    calculateIRPF: function (base) {
        if (base <= 0) return 0;

        // Simulação 2024 (Exemplo) - Tabela Progressiva Anual
        // Até 24k isento
        // ...
        // Simplificado:

        let tax = 0;
        if (base > 60000) {
            tax = (base * 0.275) - 10000;
        } else {
            tax = base * 0.075;
        }

        return tax > 0 ? tax : 0;
    },

    formatCurrency: function (val) {
        return (val || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    formatDate: function (str) {
        if (!str) return '-';
        return new Date(str).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
    }
};
